import React, {useState} from 'react';
import Sidenav from '../components/Sidenav/Sidenav';
import {Outlet, useNavigate} from "react-router-dom";
import st from './MainLayout.module.scss';
import cx from 'classnames';
import {useAuth, useMenu} from "../context/context";
import {Button} from "antd";
import {
    LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined,
} from '@ant-design/icons';

const MainLayout = () => {
    const navigate = useNavigate();
    const {menuIsCollapsed, toggleCollapsed} = useMenu();
    const {logout} = useAuth();

    return (
        <>
            <div className={cx(st.header, {[st.menuIsCollapsed]: menuIsCollapsed})}>
                <Button
                    type="primary"
                    onClick={toggleCollapsed}
                    style={{
                        marginBottom: 16,
                    }}
                >
                    {menuIsCollapsed ? <MenuUnfoldOutlined/> : <MenuFoldOutlined/>}
                </Button>
                <Button
                    onClick={() => {
                        logout();
                        navigate("/login");
                    }}
                    style={{
                        marginBottom: 16,
                    }}
                >
                    <LogoutOutlined/>
                    Logout
                </Button>
            </div>
            <div className={st.layoutContainer}>
                <Sidenav menuIsCollapsed={menuIsCollapsed} toggleCollapsed={toggleCollapsed}/>
                <div className={cx(st.outletContainer, {[st.wideContainer]: menuIsCollapsed})}><Outlet/></div>
            </div>
        </>
    );
}

export default MainLayout;